import type { GroupingGroup } from '@vedalib/editor/lib/elements'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldArray, FieldSegmented, FormField } from 'components/formKit'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'
import { chainName } from 'utils/form'

import GroupingFormValueAddGroup from './GroupingFormValueAddGroup'
import GroupingFormValueProvider from './GroupingFormValueContext'
import GroupingFormValueItemGroup from './GroupingFormValueItemGroup'
import type { GroupingValueFormType } from './groupingTypes'

const HAS_GROUP_IMAGE = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'hasGroupImage',
  label: t('elements.grouping.form.hasGroupImage.label'),
  defaultValue: false,
})

const HAS_ANSWER_IMAGE = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'hasAnswerImage',
  label: t('elements.grouping.form.answer.label'),
  defaultValue: false,
})

const ITEMS = genElementValueField({
  as: FieldArray<GroupingGroup>,
  name: 'items',
  props: {
    RenderItem: GroupingFormValueItemGroup,
    RenderAdd: GroupingFormValueAddGroup,
    min: 2,
    max: 4,
  },
})

const GroupingForm: GroupingValueFormType = ({ name }) => (
  <Padding bottom gap sides>
    <GroupingFormValueProvider>
      <FormField config={chainName(name, HAS_GROUP_IMAGE)} />
      <FormField config={chainName(name, HAS_ANSWER_IMAGE)} />
      <Typography styleType='hint'>{t('elements.grouping.form.groupHint')}</Typography>
      <FormField config={chainName(name, ITEMS)} />
    </GroupingFormValueProvider>
  </Padding>
)

export default GroupingForm
